module.exports = __webpack_public_path__ + "static/media/itemCreated.7475bd80.png";